'use strict';

exports.__esModule = true;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var HttpsRedirection = function (_Component) {
  _inherits(HttpsRedirection, _Component);

  function HttpsRedirection() {
    _classCallCheck(this, HttpsRedirection);

    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  HttpsRedirection.prototype.componentWillMount = function componentWillMount() {
    // Force redirect to https if not on local development
    if (!this.props.disableHttps) {
      if (window.location.protocol !== 'https:') {
        window.location.href = window.location.href.replace('http://', 'https://');
      }
    }
  };

  HttpsRedirection.prototype.render = function render() {
    return _react2.default.createElement(
      'div',
      null,
      this.props.children
    );
  };

  return HttpsRedirection;
}(_react.Component);

HttpsRedirection.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes2.default.node.isRequired,
  disableHttps: _propTypes2.default.bool
} : {};

HttpsRedirection.defaultProps = {
  disableHttps: false
};

exports.default = HttpsRedirection;
module.exports = exports['default'];